import React from 'react'
import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, Title, Tooltip, Legend } from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, Title, Tooltip, Legend)

export const BarGraph = ({ data, isMobile }) => {
    const options = { indexAxis: 'x', maintainAspectRatio: !isMobile }

    return <Bar data={data} options={options} />
}
